import is_report from "./IsReport"

const is_big_report = {
    mixins: [is_report],
    mounted () {
        this.scope_watermark = this.state.scope
    },
    methods: {
        reload (refreshing = true) {
            this.scope_watermark = this.state.scope
            this.refreshing = refreshing
            if(!this.refreshing) this.loading = true
            this.load()
        },
        set_scope (scope) {
            const reload = scope > this.scope_watermark
            this.set_state_value("scope", scope)
            if(reload) {
                this.scope_watermark = scope
                this.load()
            }
        },
        set_state_value_and_reload (key, value) {
            this.set_state_values({ [key]: value })
            this.load()
        }
    },
    data () {
        return {
            scope_watermark: 0
        }
    }
}

export default is_big_report
